export default {
  'SimpleAvgRating.title': 'Средний рейтинг',
  'SimpleAvgRating.tooltipText':
    'Средний рейтинг рассчитывается на основе рейтинга всех товаров в вашем аккаунте',
}
